import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconFlipVertical: React.FC<IconProps> = ({ width = 14, height = 14, color = '#303030' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
        >
            <g clip-path="url(#clip0_6109_13841)">
                <path d="M1.16699 0L5.33366 5L9.41699 0H1.16699Z" fill={color} />
                <path
                    d="M5.25 7.5L1.16667 12.5H9.5L5.25 7.5ZM2.91667 11.6667L5.25 8.83333L7.75 11.6667H2.91667Z"
                    fill={color}
                />
                <path d="M9.5 5.83203V6.66536H8.66667V5.83203H9.5Z" fill={color} />
                <path d="M11.167 5.83203V6.66536H10.3337V5.83203H11.167Z" fill={color} />
                <path d="M7.83301 5.83203V6.66536H6.99967V5.83203H7.83301Z" fill={color} />
                <path d="M6.16699 5.83203V6.66536H5.33366V5.83203H6.16699Z" fill={color} />
                <path d="M4.5 5.83203V6.66536H3.66667V5.83203H4.5Z" fill={color} />
                <path d="M2.83301 5.83203V6.66536H1.99967V5.83203H2.83301Z" fill={color} />
                <path d="M1.16699 5.83203V6.66536H0.333659V5.83203H1.16699Z" fill={color} />
                <path
                    d="M12.8337 6.2513C12.8337 7.33464 12.2503 8.41797 11.2503 9.2513L10.3337 8.33464V10.8346H12.8337L11.8337 9.83464C13.0003 8.83464 13.667 7.58464 13.667 6.2513C13.667 4.66797 12.8337 3.2513 11.2503 2.16797L10.7503 2.83464C12.0837 3.7513 12.8337 4.91797 12.8337 6.2513Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_6109_13841">
                    <rect
                        width="13.3333"
                        height="13.3333"
                        fill="white"
                        transform="matrix(0 1 -1 0 13.667 0)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconFlipVertical;
